/**
 * 日期格式化工具函数
 */

/**
 * 格式化日期为本地字符串
 * @param dateString - ISO 日期字符串或日期对象
 * @param locale - 可选的区域设置，默认使用 'zh-CN'
 * @returns 格式化后的日期字符串
 */
export const formatDate = (
  dateString: string | Date,
  locale: string = 'zh-CN'
): string => {
  const date = typeof dateString === 'string' ? new Date(dateString) : dateString
  
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

/**
 * 格式化日期时间为本地字符串
 * @param dateString - ISO 日期字符串或日期对象
 * @param locale - 可选的区域设置，默认使用 'zh-CN'
 * @returns 格式化后的日期时间字符串
 */
export const formatDateTime = (
  dateString: string | Date,
  locale: string = 'zh-CN'
): string => {
  const date = typeof dateString === 'string' ? new Date(dateString) : dateString
  
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

/**
 * 获取相对时间（例如：3 分钟前、2 小时前）
 * @param dateString - ISO 日期字符串或日期对象
 * @returns 相对时间字符串
 */
export const getRelativeTime = (dateString: string | Date): string => {
  const date = typeof dateString === 'string' ? new Date(dateString) : dateString
  const now = new Date()
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000)
  
  const intervals = [
    { label: '年', seconds: 31536000 },
    { label: '个月', seconds: 2592000 },
    { label: '天', seconds: 86400 },
    { label: '小时', seconds: 3600 },
    { label: '分钟', seconds: 60 }
  ]
  
  for (const interval of intervals) {
    const count = Math.floor(diffInSeconds / interval.seconds)
    if (count >= 1) {
      return `${count} ${interval.label}前`
    }
  }
  
  return '刚刚'
}

/**
 * 检查日期是否有效
 * @param dateString - 日期字符串或日期对象
 * @returns 日期是否有效
 */
export const isValidDate = (dateString: string | Date): boolean => {
  const date = typeof dateString === 'string' ? new Date(dateString) : dateString
  return date instanceof Date && !isNaN(date.getTime())
}
